import { TraceXInterceptor } from '@trace-x/trace-x-generator';
import {AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  DataShareService,
  SurfAuthenticationService,
  SurfClientSupportService,
  SurfCriteriaUtil,
  SurfDeviceDetectorService,
  SurfExternalProductCriteriaEventService,
  SurfHealthCheckService,
  SurfLoggerService,
  SurfPerformanceLogService,
  SurfRedirectUrlCaptureServiceService,
  SurfStaticDataService,
  SurfUtilService
} from '@surf/surf-components-core';
import { TcHttpError } from '@tc-core/model/it/codegen/tbx/ext/errors/tc-http-error';
import { LoggerService } from '@tc-core/service/helpers/logging';
import { ClientSearchServiceHandler, DataServiceHandler } from '@tc-core/service/service-handlers';
import { ConfigLoader, LogStore } from '@tc-core/util/framework';
import { DataStore } from '@tc-core/util/framework/data-store.service';
import { CommonHelper } from '@tc-core/util/helpers';
import { CookieService } from 'ngx-cookie-service';
import { Subscription } from 'rxjs';
import { AppService } from '../../../app.service';
import { B2bDashboardComponent } from '../b2b-dashboard.component';
import { HelperService } from './helper.service';
import { TC } from '@tc-core/util';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'surf-b2b-dashboard-v2',
  templateUrl: './dashboard-v2.component.html',
})
export class DashboardV2Component extends B2bDashboardComponent implements OnInit, OnDestroy, AfterViewInit {

  @Input() currentImageUrl = '';
  private promoRecommendationSubscription: Subscription;
  promoRecommendationList = [];
  enableDashboardDetailView = false;
  enableTariffView = false;
  isBookingSearchInputFocussed = false;
  carouselTimer: any;
  images = [];

  ENABLE_DASHBOARD_HIGHLIGHTS_COLLAPSED_VIEW = true;
  SURF_LANDING_CAROUSEL_IMAGES = '';
  SURF_LANDING_CAROUSEL_SLIDE_INTERVAL = 2000;
  SURF_RECOMMENDATION_SLIDE_INTERVAL = 3000;
  SURF_RECOMMENDATION_OPEN_IN_NEW_TAB = true;
  ENABLE_SURF_TARIFF = true;

  constructor(
    protected dataShare: DataShareService,
    protected surfPerformanceLogService: SurfPerformanceLogService,
    protected deviceService: SurfDeviceDetectorService,
    protected healthCheckServiice: SurfHealthCheckService,
    protected dataServiceHandler: DataServiceHandler,
    protected dataStore: DataStore,
    protected logStore: LogStore,
    public surfCriteriaUtil: SurfCriteriaUtil,
    protected surfStaticDataService: SurfStaticDataService,
    protected appService: AppService,
    protected surfLoggerService: SurfLoggerService,
    protected loggerService: LoggerService,
    protected clientSearchServiceHandler: ClientSearchServiceHandler,
    protected commonHelper: CommonHelper,
    protected configLoader: ConfigLoader,
    protected route: ActivatedRoute,
    protected router: Router,
    protected cookieService: CookieService,
    protected surfUtilService: SurfUtilService,
    protected surfRedirectUrlCaptureServiceService: SurfRedirectUrlCaptureServiceService,
    protected surfClientSupportService: SurfClientSupportService,
    protected surfExternalProductCriteriaEventService: SurfExternalProductCriteriaEventService,
    protected authenticationService: SurfAuthenticationService,
    private helperService: HelperService,
    private elementRef: ElementRef,
  ) {
    super(
      dataShare,
      surfPerformanceLogService,
      deviceService,
      healthCheckServiice,
      dataServiceHandler,
      dataStore,
      logStore,
      surfCriteriaUtil,
      surfStaticDataService,
      appService,
      surfLoggerService,
      loggerService,
      clientSearchServiceHandler,
      commonHelper,
      configLoader,
      route,
      router,
      cookieService,
      surfUtilService,
      surfRedirectUrlCaptureServiceService,
      surfClientSupportService,
      surfExternalProductCriteriaEventService,
      authenticationService
    );
  }

  ngOnInit(): void {
    TraceXInterceptor.interceptTrace('dashboard/src/app/modules/b2b-dashboard/dashboard-v2/dashboard-v2.component.ts.DashboardV2Component.ngOnInit');
    super.ngOnInit();
    // we are using an unused API to get the list of promotional recommendation list.
    this.promoRecommendationSubscription = this.dataServiceHandler
      .getCruiseLines()
      .subscribe(
        (res) => {
          if (res && !(res instanceof TcHttpError)) {
            res.forEach((item) => {
              console.log(item);
              this.dataShare.getKeyParamString().subscribe((keyParams) => {
                // update resultsCount
                // if (this.HTL_SEARCH_RESULT_COUNT && this.HTL_SEARCH_RESULT_COUNT.length > 0) {
                //   const tempList = keyParams.split('resultsCount=');
                //   if (tempList[1]) {
                //     const sliceIndex = tempList[1].indexOf('&') >= 0 ? tempList[1].indexOf('&') : tempList[1].length;
                //     tempList[1] = this.HTL_SEARCH_RESULT_COUNT + tempList[1].slice(sliceIndex);
                //   } else {
                //     tempList[1] = this.HTL_SEARCH_RESULT_COUNT;
                //   }
                // keyParams = tempList.join('resultsCount=');
                // }
                if (keyParams && this.promoRecommendationList.length === 0) {
                  this.promoRecommendationList =
                    this.helperService.convertResponseToRecommendationList(
                      res,
                      keyParams
                    );
                }
              });
            });
          }
        },
        (error) => {
          console.log('Error in getting promotional recommendation list');
        }
      );
    this.SURF_LANDING_CAROUSEL_IMAGES = this.configLoader.getModuleConfig(
      'SURF_LANDING_CAROUSEL_IMAGES',
      TC.MODULE_NAME.SURF_B2B
    );

    const OPEN_IN_NEW_TAB = this.configLoader.getModuleConfig(
      'SURF_RECOMMENDATION_OPEN_IN_NEW_TAB',
      TC.MODULE_NAME.SURF_B2B
    );

    this.SURF_RECOMMENDATION_OPEN_IN_NEW_TAB = OPEN_IN_NEW_TAB.toString().toUpperCase() === 'TRUE'
      || OPEN_IN_NEW_TAB.toString().toUpperCase() === 'YES';

    const CAROUSEL_SLIDE_INTERVAL = +this.configLoader.getModuleConfig(
      'SURF_LANDING_CAROUSEL_SLIDE_INTERVAL',
      TC.MODULE_NAME.SURF_B2B
    );

    const OFFER_SLIDE_INTERVAL = +this.configLoader.getModuleConfig(
      'SURF_RECOMMENDATION_SLIDE_INTERVAL',
      TC.MODULE_NAME.SURF_B2B
    );

    if (CAROUSEL_SLIDE_INTERVAL && CAROUSEL_SLIDE_INTERVAL > 0) {
      this.SURF_LANDING_CAROUSEL_SLIDE_INTERVAL = CAROUSEL_SLIDE_INTERVAL;
    }

    if (OFFER_SLIDE_INTERVAL && OFFER_SLIDE_INTERVAL > 0) {
      this.SURF_RECOMMENDATION_SLIDE_INTERVAL = OFFER_SLIDE_INTERVAL;
    }

    this.images = this.SURF_LANDING_CAROUSEL_IMAGES?.split(',');
    this.setDashboardSearchBackgroundImage();

    this.ENABLE_SURF_TARIFF = this.configLoader.getModuleConfig(
      'ENABLE_SURF_TARIFF',
      TC.MODULE_NAME.SURF_B2B
    )?.toString()?.toUpperCase() === 'TRUE';
  }

  ngOnDestroy(): void {
    TraceXInterceptor.interceptTrace('dashboard/src/app/modules/b2b-dashboard/dashboard-v2/dashboard-v2.component.ts.DashboardV2Component.ngOnDestroy');
    this.promoRecommendationSubscription.unsubscribe();
    if (this.carouselTimer) {
      clearInterval(this.carouselTimer);
    }
  }

  ngAfterViewInit(): void {
    TraceXInterceptor.interceptTrace('dashboard/src/app/modules/b2b-dashboard/dashboard-v2/dashboard-v2.component.ts.DashboardV2Component.ngAfterViewInit');
    super.ngAfterViewInit();
  }

  setDashboardSearchBackgroundImage(): void {
    TraceXInterceptor.interceptTrace('dashboard/src/app/modules/b2b-dashboard/dashboard-v2/dashboard-v2.component.ts.DashboardV2Component.setDashboardSearchBackgroundImage');
    const images = this.images;
    if (!images || images.length === 0) {
      throw new Error('Dashboard search element or images are not available');
    }

    // set currentIndex as 1 as the initial image is loaded as input to the component
    let currentIndex = 1;
    this.carouselTimer = setInterval(() => {
      this.currentImageUrl = images[currentIndex];
      currentIndex = (currentIndex + 1) % images.length;
    }, this.SURF_LANDING_CAROUSEL_SLIDE_INTERVAL);
  }

  goToDetailsView(): void {
    TraceXInterceptor.interceptTrace('dashboard/src/app/modules/b2b-dashboard/dashboard-v2/dashboard-v2.component.ts.DashboardV2Component.goToDetailsView');
    this.enableDashboardDetailView = true;

    // clears the carousel background image change ones the user navigates to details view
    clearInterval(this.carouselTimer);
  }

  backToLandingView(): void {
    TraceXInterceptor.interceptTrace('dashboard/src/app/modules/b2b-dashboard/dashboard-v2/dashboard-v2.component.ts.DashboardV2Component.backToLandingView');
    this.enableDashboardDetailView = false;
    this.enableTariffView = false;

    // wait until the view is rendered
    setTimeout(() => {
      // resets the carousel background image change ones the user navigates to landing view
      this.setDashboardSearchBackgroundImage();
    }, 0);
  }

  onToggleRetailStoreViewStatus() {
    TraceXInterceptor.interceptTrace('dashboard/src/app/modules/b2b-dashboard/dashboard-v2/dashboard-v2.component.ts.DashboardV2Component.onToggleRetailStoreViewStatus');
    this.setBookingSearchInputFocus();
  }

  setBookingSearchInputFocus() {
    TraceXInterceptor.interceptTrace('dashboard/src/app/modules/b2b-dashboard/dashboard-v2/dashboard-v2.component.ts.DashboardV2Component.setBookingSearchInputFocus');
    this.isBookingSearchInputFocussed = true;
  }

  goToTariffView() {
    TraceXInterceptor.interceptTrace('dashboard/src/app/modules/b2b-dashboard/dashboard-v2/dashboard-v2.component.ts.DashboardV2Component.goToTariffView');
    this.enableTariffView = true;
  }
}
